import Logout from './shared/auth/Logout';
import ResetUser from './shared/auth/ResetUser';
import {Store} from '@ngxs/store';

export const logout = async (store: Store) => {
    try {
        await store.dispatch(new Logout()).toPromise();
    } catch (e) {
        //
    } finally {
        await store.dispatch(new ResetUser()).toPromise();
    }
};
